import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import LeasingForm from "./LeasingForm";
import Podsumowanie from "./Podsumowanie";
import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

/* ---------------- GTM noscript (iframe w <body>) ---------------- */
function GTMNoScript() {
  return (
    <noscript>
      <iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-5K9Z27XD"
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="gtm"
      />
    </noscript>
  );
}

/* ---------------- Pageview na zmianę trasy ---------------- */
function useGtmPageView() {
  const location = useLocation();
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: location.pathname + location.search,
      page_title: document.title || "Aureus – bezpłatna konsultacja",
    });
  }, [location]);
}

function AppInner() {
  useGtmPageView();

  useEffect(() => {
    // Consent Mode v2 (domyślnie DENIED — CookieYes później zaktualizuje)
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });

    // Google Tag Manager
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-5K9Z27XD");

    // CookieYes
    const cookieScript = document.createElement("script");
    cookieScript.id = "cookieyes";
    cookieScript.type = "text/javascript";
    cookieScript.src = "https://cdn-cookieyes.com/client_data/5707a70a9458fcf02a1e6fe2/script.js";
    cookieScript.async = true;
    document.body.appendChild(cookieScript);
  }, []);

  return (
    <>
      <Helmet>
        <title>Bezpłatna konsultacja – leasing i ubezpieczenia | Aureus</title>
        <meta
          name="description"
          content="Umów bezpłatną konsultację z ekspertem Aureus. Porównamy oferty leasingu i ubezpieczeń, odpowiemy na pytania i pokażemy, jak oszczędzić czas i pieniądze. Godziny: pon.–pt., 8:00–16:00."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="UTF-8" />
        <meta name="robots" content="index, follow" />
        <link
          rel="icon"
          href="https://aureus.pl/wp-content/uploads/2021/01/favicon.ico"
        />
      </Helmet>

      {/* noscript iframe dla GTM */}
      <GTMNoScript />

      <Routes>
        {/* Nowa główna ścieżka */}
        <Route path="/bezplatna-konsultacja" element={<LeasingForm />} />
        <Route path="/bezplatna-konsultacja/podsumowanie" element={<Podsumowanie />} />

        {/* Stare/alternatywne adresy -> przekieruj na nowy */}
        <Route path="/" element={<Navigate to="/bezplatna-konsultacja" replace />} />
        <Route path="/kalkulacja-leasingu/*" element={<Navigate to="/bezplatna-konsultacja" replace />} />
        <Route path="/leasing-gliwice" element={<Navigate to="/bezplatna-konsultacja" replace />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/bezplatna-konsultacja" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      {/* Używamy Routera bez basename — pathy ustawione explicite wyżej */}
      <Router>
        <AppInner />
      </Router>
    </HelmetProvider>
  );
}

export default App;
